module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-562.aecfef1.woff2";